import type { HeroTrustChip } from "@/components/landing/Hero/types";
import { Glyph } from "@/components/landing/shared";

const CHIP_GLYPHS = ["isolation", "rocket", "bilingual", "support"] as const;

interface HeroTrustChipsProps {
	chips: HeroTrustChip[];
}

function HeroTrustChips(prop: HeroTrustChipsProps) {
	const { chips } = prop;
	return (
		<div className="mt-9 grid grid-cols-2 gap-3 sm:grid-cols-4">
			{chips.map((chip, i) => (
				<div key={chip.title} className="flex items-center gap-2.5">
					<span
						className="grid h-9 w-9 shrink-0 place-items-center rounded-full"
						style={{
							background: "color-mix(in srgb, var(--brand-2) 14%, transparent)",
							color: "var(--brand-1)",
						}}
					>
						<Glyph name={CHIP_GLYPHS[i % CHIP_GLYPHS.length]} className="h-4.5 w-4.5" />
					</span>
					<span className="text-sm leading-tight">
						<span className="block font-semibold">{chip.title}</span>
						<span className="block text-muted-foreground">{chip.subtitle}</span>
					</span>
				</div>
			))}
		</div>
	);
}

export default HeroTrustChips;
